import Introduction from "../../componets/Introduction";

export default function Section2() {
  return (
    <div className="Section2">
      <Introduction
        title="Unlock Creativity with Our Product & Merchandise Designing Services"
        text="Transform your ideas into captivating products and merchandise that leave a lasting impression. At Mean3, we specialize in innovative and visually stunning product and merchandise design services that help you stand out in a crowded marketplace. Whether you're a startup, small business, or a well-established brand, our team is here to bring your vision to life."
        divider={true}
      />
    </div>
  );
}
